import { SymbolInfo } from './symbolInfoSlice';
import {
    ColumnDefinitionsDictionary,
    ValueType,
} from '@instinet-analytics/semantic-ui-components';

export type SymbolInfoColumns = keyof SymbolInfo;

export const symbolInfoColumnDefinitionDictionary: ColumnDefinitionsDictionary<SymbolInfoColumns> =
    {
        iSymbol: {
            field: 'iSymbol',
            name: 'Instinet Symbol',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        bloomSymbol: {
            field: 'bloomSymbol',
            name: 'Bloomberg Symbol',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        assetClass: {
            field: 'assetClass',
            name: 'Asset Class',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        region: {
            field: 'region',
            name: 'Region',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        country: {
            field: 'country',
            name: 'Country',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        exchangeSymbol: {
            field: 'exchangeSymbol',
            name: 'Exchange Symbol',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        currencyCode: {
            field: 'currencyCode',
            name: 'Currency Code',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        description: {
            field: 'description',
            name: 'Description',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        isin: {
            field: 'isin',
            name: 'Isin',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        symbolIndex: {
            field: 'symbolIndex',
            name: 'Symbol Index',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        industry: {
            field: 'industry',
            name: 'Industry',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        sector: {
            field: 'sector',
            name: 'Sector',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        subIndustry: {
            field: 'subIndustry',
            name: 'Sub Industry',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        superSector: {
            field: 'superSector',
            name: 'Super Sector',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
        securityType: {
            field: 'securityType',
            name: 'Security Type',
            valueType: ValueType.STRING,
            textAlign: 'left',
        },
    };
